import { useMemo } from 'react';
import { useGetMeetingsQuery } from '../api';
/**
 * Hook to get meetings data for a given project.
 *
 * @param params - Parameters including projectId to filter meetings by project
 * @returns an object with meetings data, loading state, error state, error object, and refetch function.
 */
export const useMeetings = (params) => {
    const { data: meetingsResponse, isLoading, isError, error, refetch, } = useGetMeetingsQuery({ projectId: params.projectId });
    return useMemo(() => ({
        meetingsResponse,
        meetings: meetingsResponse?.meetings || [],
        isLoading,
        isError,
        error,
        refetch,
    }), [error, isError, isLoading, meetingsResponse, refetch]);
};
